export const LOGIN_INFO = 'LOGIN_INFO';
export const SET_SCORE = 'SET_SCORE';
export const SET_CONFIG = 'SET_CONFIG';
export const RESET_CONFIG = 'RESET_CONFIG';
